import { FC, Suspense } from 'react'

const withSuspense = <P,>(WrappedComponent: React.ComponentType<P>): FC<P> => {
  const Component = (props: P) => (
    <Suspense fallback={null}>
      <WrappedComponent {...(props as any)} />
    </Suspense>
  )
  Component.displayName = `withSuspense(${WrappedComponent.name})`
  return Component
}

export { withSuspense }
